export type ImportedModelDisplayType = 'assembly' | 'part' | 'unknown'

export type ImportedModelLoadStrategy = 'assembly-structure' | 'part-asset' | 'legacy'

export interface ImportedModelAnalysis {
  explicitSemantic: 'assembly' | 'part' | null
  hasAssemblyManifest: boolean
  referencedPartUuids: string[]
  canBuildPartAsset: boolean
  warnings: string[]
}

export interface ImportedModelLoadPlan {
  displayType: ImportedModelDisplayType
  loadStrategy: ImportedModelLoadStrategy
  evidence: {
    explicitSemantic: ImportedModelAnalysis['explicitSemantic']
    hasAssemblyManifest: boolean
    referencedPartCount: number
    canBuildPartAsset: boolean
  }
}

export function planImportedModelLoad(
  analysis: ImportedModelAnalysis,
): ImportedModelLoadPlan {
  if (analysis.explicitSemantic === 'assembly') {
    return {
      displayType: 'assembly',
      loadStrategy: 'assembly-structure',
      evidence: {
        explicitSemantic: analysis.explicitSemantic,
        hasAssemblyManifest: analysis.hasAssemblyManifest,
        referencedPartCount: analysis.referencedPartUuids.length,
        canBuildPartAsset: analysis.canBuildPartAsset,
      },
    }
  }

  if (analysis.explicitSemantic === 'part') {
    return {
      displayType: 'part',
      loadStrategy: 'part-asset',
      evidence: {
        explicitSemantic: analysis.explicitSemantic,
        hasAssemblyManifest: analysis.hasAssemblyManifest,
        referencedPartCount: analysis.referencedPartUuids.length,
        canBuildPartAsset: analysis.canBuildPartAsset,
      },
    }
  }

  if (analysis.hasAssemblyManifest && analysis.referencedPartUuids.length > 0) {
    return {
      displayType: 'unknown',
      loadStrategy: 'assembly-structure',
      evidence: {
        explicitSemantic: null,
        hasAssemblyManifest: true,
        referencedPartCount: analysis.referencedPartUuids.length,
        canBuildPartAsset: analysis.canBuildPartAsset,
      },
    }
  }

  if (analysis.canBuildPartAsset) {
    return {
      displayType: 'unknown',
      loadStrategy: 'part-asset',
      evidence: {
        explicitSemantic: null,
        hasAssemblyManifest: analysis.hasAssemblyManifest,
        referencedPartCount: analysis.referencedPartUuids.length,
        canBuildPartAsset: true,
      },
    }
  }

  return {
    displayType: 'unknown',
    loadStrategy: 'legacy',
    evidence: {
      explicitSemantic: null,
      hasAssemblyManifest: analysis.hasAssemblyManifest,
      referencedPartCount: analysis.referencedPartUuids.length,
      canBuildPartAsset: false,
    },
  }
}
